import type { FiltersGroupId } from '@/app/common/filters/core/filtersTypes.ts';
import { CUSTOM_GROUP_NAME, FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';

export const FILTER_CODE: Partial<Record<FiltersGroupId, string>> = {
  [FILTER_NAME.PRICE_RANGE]: 'pr',
  [FILTER_NAME.MEAL_PLAN]: 'mp',
  [FILTER_NAME.SORT]: 'so',
  [FILTER_NAME.STARS]: 'st',
  [FILTER_NAME.RATING]: 'rt',
  [FILTER_NAME.PROPERTY_TYPE]: 'pt',
  [FILTER_NAME.PROPERTY_STYLE]: 'ps',
  [FILTER_NAME.PROPERTY_NAME]: 'pn',
  [FILTER_NAME.DESTINATION_AIRPORT]: 'da',
  [FILTER_NAME.OVERNIGHT_FLIGHTS]: 'of',
  [FILTER_NAME.DIRECT_FLIGHT]: 'df',
  [FILTER_NAME.BLUE_FLAG]: 'bf',
  [FILTER_NAME.ACCOMMODATION_SKI_LIFT]: 'sk',
  [FILTER_NAME.ACCOMMODATION_CHAIN]: 'ch',
  [FILTER_NAME.ACCOMMODATION_BEACH]: 'ab',
  [FILTER_NAME.ACCOMMODATION_STATION]: 'as',
  [FILTER_NAME.ACCOMMODATION_DISTRICT]: 'ad',
  [FILTER_NAME.BEACH_TYPE]: 'bt',
  [FILTER_NAME.CLIMATE]: 'cl',
  [FILTER_NAME.LEISURE_TYPE]: 'lt',
  [FILTER_NAME.ENTERTAINMENT]: 'en',
  [FILTER_NAME.FAUNA]: 'fn',
  [FILTER_NAME.WATER_SPORTS]: 'ws',
  [FILTER_NAME.WATER_WAVES]: 'ww',
  [FILTER_NAME.SUSTAINABILITY_CERTIFICATE]: 'sc',
  [CUSTOM_GROUP_NAME.FACILITIES]: 'fa',
  [CUSTOM_GROUP_NAME.BOOKING_OPTIONS]: 'bo',
  [CUSTOM_GROUP_NAME.DISCOUNT_OPTIONS]: 'do',
};

const GROUP_BY_CODE: Record<string, FiltersGroupId> = Object.fromEntries(
  Object.entries(FILTER_CODE).map(([groupId, code]) => [code, groupId as FiltersGroupId])
);

export const codeForGroup = (groupId: string): string | undefined =>
  Object.hasOwn(FILTER_CODE, groupId) ? (FILTER_CODE as Record<string, string | undefined>)[groupId] : undefined;

export const groupForCode = (code: string): FiltersGroupId | undefined =>
  Object.hasOwn(GROUP_BY_CODE, code) ? GROUP_BY_CODE[code] : undefined;
